/**
 * Business-error model for the My Licence settings form.
 *
 * Discriminated union: the generic `network` / `api` transport failures (from the
 * app-wide `@/utils/infra-error` classifier) plus the form-specific `validation`
 * variant (field-level messages produced by `validateDraft`). Local to the feature
 * so it never couples to another domain.
 */
import { classifyInfraError, type InfraFailure } from '@/utils/infra-error';

export type MyLicenceError =
  | InfraFailure
  | { kind: 'validation'; fields: Record<string, string> };

/**
 * Map an infrastructure error into a domain `MyLicenceError`. Only ever yields a
 * `network` / `api` failure; `validation` errors are produced directly by the
 * feature's `validateDraft`.
 */
export function toMyLicenceError(e: unknown): MyLicenceError {
  return classifyInfraError(e, 'Failed to update licence.');
}
